module.exports = __webpack_public_path__ + "static/Verify-a76ad773abd2f79cb5779aeac76153dc.png";